module.exports = __webpack_public_path__ + "static/media/7_scratch_a.3a812216.ogg";